import { render, staticRenderFns } from "./TermCoverage.vue?vue&type=template&id=7c0b6dbb&scoped=true"
import script from "./TermCoverage.vue?vue&type=script&lang=js"
export * from "./TermCoverage.vue?vue&type=script&lang=js"
import style0 from "./TermCoverage.vue?vue&type=style&index=0&id=7c0b6dbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0b6dbb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VFlex,VLayout})
